module.exports = __webpack_public_path__ + "static/media/user-active.dfd0778f.svg";